export default __webpack_public_path__ + "static/media/detail_big_5_4.16bd9dd6.png";